module.exports = __webpack_public_path__ + "static/media/csat-widget-preview.f997ce19.png";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/CSATWidget/csat-widget-preview.png
// module id = 6001
// module chunks = 13